import { createUseStyles } from 'react-jss'
import { siteLink } from '../../../../styles/common'

const useStyles = createUseStyles({
  link: {
    extend: siteLink
  }
})

export default useStyles
